
export function selectSidebarOptionFromUrl(path) {

    switch (true) {
        case (/^\/clients\/activities/).test(path): return {
            "selectedSubSidebarOptions": "activities",
            "selectedParentSubSidebarOptions": "activities",
            "key": "activities"
        };
        case (/^\/clients\/candidates/).test(path): return {
            "selectedSubSidebarOptions": "candidates",
            "selectedParentSubSidebarOptions": "candidates",
            "key": "candidates"
        };
        case (/^\/clients\/add-candidate/).test(path): return {
            "selectedSubSidebarOptions": "candidates",
            "selectedParentSubSidebarOptions": "candidates",
            "key": "candidates"
        };
        case (/^\/clients\/add-offer/).test(path): return {
            "selectedSubSidebarOptions": "candidates",
            "selectedParentSubSidebarOptions": "candidates",
            "key": "candidates"
        };
        case (/^\/clients\/jobs\/.*\/kanban/).test(path): return {
            "selectedSubSidebarOptions": "jobs",
            "selectedParentSubSidebarOptions": "jobs",
            "key": "jobs"
        };
        case (/^\/clients\/view-scorecards/).test(path): return {
            "selectedSubSidebarOptions": "candidates",
            "selectedParentSubSidebarOptions": "candidates",
            "key": "candidates"
        };
        case (/^\/clients\/errorpages\/404/).test(path): return {
            "selectedSubSidebarOptions": "candidates",
            "selectedParentSubSidebarOptions": "candidates",
            "key": "candidates"
        };
        // --------------------------------------------- REPORTS -------------------------------------
        // case (/^\/clients\/reports/).test(path)                                                 :   return  {  "selectedSubSidebarOptions":"reports",
        //                                                                                                       "selectedParentSubSidebarOptions" :"reports",
        //                                                                                                         "key": "reports"
        //                                                                                                     };

        case (/^\/clients\/reports\/candidate-overview\/.*\/pipeline-health/).test(path): return {
            "selectedSubSidebarOptions": "in-process",
            "key": "reports"
        };
        case (/^\/clients\/reports\/candidate-overview\/time-to-hire/).test(path): return {
            "selectedSubSidebarOptions": "time-to-hire",
            "key": "reports"
        };
        case (/^\/clients\/reports\/candidate-overview\/source/).test(path): return {
            "selectedSubSidebarOptions": "source",
            "key": "reports"
        };
        case (/^\/clients\/reports\/candidate-overview\/advance-source\?/).test(path): return {
            "selectedSubSidebarOptions": "source",
            "key": "reports"
        };
        case (/^\/clients\/reports\/candidate-overview\/in-process/).test(path): return {
            "selectedSubSidebarOptions": "in-process",
            "key": "reports"
        };


        // Job Overview  //
        case (/^\/clients\/reports\/job-overview\/total-jobs-live-overtime/).test(path): return {
            "selectedSubSidebarOptions": "total-jobs-live-overtime",
            "key": "reports"
        };


        case (/^\/clients\/reports\/job-overview\/live-jobs-by-age/).test(path): return {
            "selectedSubSidebarOptions": "live-jobs-by-age",
            "key": "reports"
        };
        // Job Overview //


        // Interview    //
        case (/^\/clients\/reports\/interviews\/current-pipeline/).test(path): return {
            "selectedSubSidebarOptions": "current_pipeline",
            "key": "reports"
        };
        case (/^\/clients\/reports\/interviews\/pipeline-speed/).test(path): return {
            "selectedSubSidebarOptions": "pipeline_speed",
            "key": "reports"
        };
    case (/^\/clients\/reports\/interviews\/pipeline-conversion/).test(path): return {
            "selectedSubSidebarOptions": "pipeline_conversion",
            "key": "reports"
        };
        // Interview //

        // --------------------------------------------- REPORTS -------------------------------------

        case (/^\/clients\/documents/).test(path): return {
            "selectedSubSidebarOptions": "documents",
            "selectedParentSubSidebarOptions": "documents",
            "key": "documents"
        };
        case (/^\/clients\/gdpr-setting$/).test(path): return {
            "selectedSubSidebarOptions": "candidates",
            "selectedParentSubSidebarOptions": "candidates",
            "key": "candidates"
        };
        case (/^\/clients\/my-integration/).test(path): return {
            "selectedSubSidebarOptions": "my-integration",
            "selectedParentSubSidebarOptions": "personal",
            "key": "settings"
        };
        case (/^\/clients\/jobs-api/).test(path): return {
            "selectedSubSidebarOptions": "jobs-api",
            "selectedParentSubSidebarOptions": "personal",
            "key": "settings"
        };
        case (/^\/clients\/my-preferences/).test(path): return {
            "selectedSubSidebarOptions": "my-preferences",
            "selectedParentSubSidebarOptions": "personal",
            "key": "settings"
        };
        case (/^\/clients\/team-list/).test(path): return {
            "selectedSubSidebarOptions": "my-preferences",
            "selectedParentSubSidebarOptions": "personal",
            "key": "settings"
        };
        case (/^\/clients\/notification-setting/).test(path): return {
            "selectedSubSidebarOptions": "notification-setting",
            "selectedParentSubSidebarOptions": "personal",
            "key": "settings"
        };
        case (/^\/clients\/clients-list/).test(path): return {
            "selectedSubSidebarOptions": "my-preferences",
            "selectedParentSubSidebarOptions": "personal",
            "key": "settings"
        };
        case (/^\/clients\/users-list/).test(path): return {
            "selectedSubSidebarOptions": "my-preferences",
            "selectedParentSubSidebarOptions": "personal",
            "key": "settings"
        };
        case (/^\/clients\/reports/).test(path): return {
            "selectedSubSidebarOptions": "my-preferences",
            "selectedParentSubSidebarOptions": "personal",
            "key": "settings"
        };


        case ("clients"): return {
            "selectedSubSidebarOptions": "clients",
            "key": "clients"
        };
        case (/^\/clients\/jobs\/.*\/applications\/.*\/candidate-profile-job\?/).test(path): return {
            "selectedSubSidebarOptions": "jobs",
            "selectedParentSubSidebarOptions": "jobs",
            "key": "jobs"
        };

        // ------------------------------------- JOBS -------------------------------------
        case (/^\/clients\/jobs\?/).test(path): return {
            "selectedSubSidebarOptions": "jobs",
            "selectedParentSubSidebarOptions": "jobs",
            "key": "jobs"
        };
        case (/^\/clients\/jobs\/candidate\/.*\/merge-listing/).test(path): return {
            "selectedSubSidebarOptions": "job-details",
            "selectedParentSubSidebarOptions": "job-details",
            "key": "jobs"
        };
        case (/^\/clients\/jobs\/candidate\/.*\/merge-record\/duplicate-candidate\/.*/).test(path): return {
            "selectedSubSidebarOptions": "job-details",
            "selectedParentSubSidebarOptions": "job-details",
            "key": "jobs"
        };
        case (/^\/clients\/jobs\/new/).test(path): return {
            "selectedSubSidebarOptions": "job-details",
            "selectedParentSubSidebarOptions": "job-details",
            "key": "jobs"
        };
        case (/^\/clients\/jobs\/.*\/edit/).test(path): return {
            "selectedSubSidebarOptions": "job-details",
            "selectedParentSubSidebarOptions": "job-details",
            "key": "jobs"
        };
        case (/^\/clients\/jobs\/.*\/job-options/).test(path): return {
            "selectedSubSidebarOptions": "job-options",
            "selectedParentSubSidebarOptions": "job-options",
            "key": "jobs"
        };
        case (/^\/clients\/jobs\/.*\/interview-stages/).test(path): return {
            "selectedSubSidebarOptions": "interview-stages",
            "selectedParentSubSidebarOptions": "interview-stages",
            "key": "jobs"
        };
        case (/^\/clients\/jobs\/.*\/interview-details/).test(path): return {
            "selectedSubSidebarOptions": "automation",
            "selectedParentSubSidebarOptions": "automation",
            "key": "jobs"
        };
        case (/^\/clients\/jobs\/.*\/scorecards/).test(path): return {
            "selectedSubSidebarOptions": "scorecards",
            "selectedParentSubSidebarOptions": "scorecards",
            "key": "jobs"
        };
        case (/^\/clients\/jobs\/.*\/job-sharing/).test(path): return {
            "selectedSubSidebarOptions": "job-sharing",
            "selectedParentSubSidebarOptions": "job-sharing",
            "key": "jobs"
        };
        case (/^\/clients\/jobs\/approval-listing/).test(path): return {
            "selectedSubSidebarOptions": "approval-listing",
            "selectedParentSubSidebarOptions": "approval-listing",
            "key": "jobs"
        };
        case (/^\/clients\/jobs\/contract-listing/).test(path): return {
            "selectedSubSidebarOptions": "contract-listing",
            "selectedParentSubSidebarOptions": "contract-listing",
            "key": "jobs"
        };
        case (/^\/clients\/jobs\/.*\/approval\/.*\/job-summary/).test(path): return{
            "selectedSubSidebarOptions": "job-summary",
            "selectedParentSubSidebarOptions": "job-summary",
            "key": "jobs"
        };
        case (/^\/clients\/jobs\/.*\/offers\/.*\/approval-request-offer/).test(path): return {
            "selectedSubSidebarOptions": "approval-request-offer",
            "selectedParentSubSidebarOptions": "approval-request-offer",
            "key": "jobs"
        };
        // ------------------------------------- JOBS -------------------------------------

         // ------------------------------------- COMMUNICATION -------------------------------------
        case (/^\/clients\/communication\?\email_type=inbox/).test(path): return {
            "selectedSubSidebarOptions": "inbox",
            "selectedParentSubSidebarOptions": "inbox",
            "key": "communication"
        };
        case (/^\/clients\/communication\?\email_type=sent/).test(path): return {
            "selectedSubSidebarOptions": "sent",
            "selectedParentSubSidebarOptions": "sent",
            "key": "communication"
        };

        case (/^\/clients\/communication\/.*\/emails\?\email_type=inbox/).test(path): return {
            "selectedSubSidebarOptions": "inbox",
            "selectedParentSubSidebarOptions": "inbox",
            "key": "communication"
        };

         case (/^\/clients\/communication\/.*\/emails\?\email_type=sent/).test(path): return {
            "selectedSubSidebarOptions": "sent",
            "selectedParentSubSidebarOptions": "sent",
            "key": "communication"
        };
        // ------------------------------------- COMMUNICATION -------------------------------------

        // ------------------------------------- SETTINGS -------------------------------------
        case (/^\/settings/).test(path): var navbarStatus = JSON.parse(localStorage.getItem('navbarStatus'));
            return {
                "selectedSubSidebarOptions": navbarStatus.selectedSubSidebarOptions,
                "selectedParentSubSidebarOptions": navbarStatus.selectedParentSubSidebarOptions,
                "key": "settings"
            };
                case (/^\/clients\/jobs\/.*\/offers\/.*\/approval-request-offer/).test(path)                            :  return {  
                                                                                                                    "selectedSubSidebarOptions":"job-details",
                                                                                                                    "selectedParentSubSidebarOptions" :"job-details",
                                                                                                                    "key" : "jobs"
                                                                                                                };

        case (/^\/clients\/my-integration/).test(path): return {
            "selectedSubSidebarOptions": "my-integration",
            "selectedParentSubSidebarOptions": "personal",
            "key": "settings"
        };

        case (/^\/clients\/my-preferences/).test(path): return {
            "selectedSubSidebarOptions": "my-preferences",
            "selectedParentSubSidebarOptions": "personal",
            "key": "settings"
        };

        case (/^\/clients\/recruitments\/email-templates/).test(path): return {
            "selectedSubSidebarOptions": "email-templates",
            "selectedParentSubSidebarOptions": "recruitment",
            "key": "settings"
        }

        case (/^\/clients\/recruitments\/email-templates/).test(path)                           :   return {  "selectedSubSidebarOptions":"email-templates",
                                                                                                    "selectedParentSubSidebarOptions" :"recruitment",
                                                                                                    "key" : "settings"}  
        case (/^\/clients\/recruitments\/calendar-invites/).test(path)                           :   return {  "selectedSubSidebarOptions":"calendar-invites",
                                                                                                    "selectedParentSubSidebarOptions" :"recruitment",
                                                                                                    "key" : "settings"}  
        
        case (/^\/clients\/recruitments\/unsuccessful-reasons/).test(path)                      :   return {  "selectedSubSidebarOptions":"unsuccessful-reasons",
                                                                                                    "selectedParentSubSidebarOptions" :"recruitment",
                                                                                                    "key" : "settings"}  

        case (/^\/clients\/recruitments\/manage-assessment/).test(path)                      :   return {  "selectedSubSidebarOptions":"manage-assessment",
                                                                                                    "selectedParentSubSidebarOptions" :"recruitment",
                                                                                                    "key" : "settings"} 
        case (/^\/clients\/recruitments\/contract-templates/).test(path)                      :   return {  "selectedSubSidebarOptions":"contract-templates",
                                                                                                    "selectedParentSubSidebarOptions" :"recruitment",
                                                                                                    "key" : "settings"}
        case (/^\/clients\/recruitments\/scorecard-templates/).test(path)                      :   return {  "selectedSubSidebarOptions":"scorecard-templates",
                                                                                                    "selectedParentSubSidebarOptions" :"recruitment",
                                                                                                    "key" : "settings"}
                                                                                                    
        case (/^\/clients\/company-integrations/).test(path)                                    :   return {  "selectedSubSidebarOptions":"company-integrations",
                                                                                                            "selectedParentSubSidebarOptions" :"integrations",
                                                                                                            "key" : "settings"};
        case (/^\/clients\/company-integrations/).test(path): return {
            "selectedSubSidebarOptions": "company-integrations",
            "selectedParentSubSidebarOptions": "integrations",
            "key": "settings"
        };

        case (/^\/clients\/activities\/.*\/integration-connected/).test(path): return {
            "selectedSubSidebarOptions": "integration-connected",
            "selectedParentSubSidebarOptions": "integrations",
            "key": "settings"
        };

        case (/^\/clients\/career\/customize-career/).test(path): return {
            "selectedSubSidebarOptions": "customize",
            "selectedParentSubSidebarOptions": "career-site",
            "key": "settings"
        };

        case (/^\/clients\/career\/career-setting/).test(path): return {
            "selectedSubSidebarOptions": "carrer-settings",
            "selectedParentSubSidebarOptions": "career-site",
            "key": "settings"
        };
        case (/^\/clients\/my-account/).test(path): return {
            "selectedSubSidebarOptions": "my-account",
            "selectedParentSubSidebarOptions": "personal",
            "key": "settings"
        };
        // ------------------------------------- SETTINGS -------------------------------------

        // ------------------------------------- QUICK SETUP -------------------------------------
        case (/^\/clients\/activities\/quick-setup?step=add_teams/).test(path): return {

            "selectedSubSidebarOptions": "add_teams",
            "selectedParentSubSidebarOptions": "add_teams",
            "key": "activities"
        };

        case (/^\/clients\/activities\/quick-setup?step=company_integrations/).test(path): return {
            "selectedSubSidebarOptions": "company_integrations",
            "selectedParentSubSidebarOptions": "company_integrations",
            "key": "activities"
        };
        case (/^\/clients\/activities\/quick-setup?step=career_page/).test(path): return {
            "selectedSubSidebarOptions": "career_page",
            "selectedParentSubSidebarOptions": "career_page",
            "key": "activities"
        };
        case (/^\/clients\/activities\/quick-setup?step=my_account/).test(path): return {
            "selectedSubSidebarOptions": "my_account",
            "selectedParentSubSidebarOptions": "my_account",
            "key": "activities"
        };
        case (/^\/clients\/activities\/quick-setup?step=my_integrations/).test(path): return {
            "selectedSubSidebarOptions": "my_integrations",
            "selectedParentSubSidebarOptions": "my_integrations",
            "key": "activities"
        };
        // ------------------------------------- QUICK SETUP -------------------------------------


        // ------------------------------------- COMPANY -------------------------------------
        case (/^\/clients\/company\/add-team/).test(path): return {
            "selectedSubSidebarOptions": "add-team",
            "selectedParentSubSidebarOptions": "company",
            "key": "settings"
        };

        case (/^\/clients\/company\/add-members/).test(path): return {
            "selectedSubSidebarOptions": "add-team",
            "selectedParentSubSidebarOptions": "company",
            "key": "settings"
        };
        case (/^\/clients\/company\/company-profile/).test(path): return {
            "selectedSubSidebarOptions": "company-profile",
            "selectedParentSubSidebarOptions": "company",
            "key": "settings"
        };

        case (/^\/clients\/company\/.*\/agency-users/).test(path): return {
            "selectedSubSidebarOptions": "agencies",
            "selectedParentSubSidebarOptions": "company",
            "key": "settings"
        };
        case (/^\/clients\/company\/.*\/.*\/agency-user-profile/).test(path): return {
            "selectedSubSidebarOptions": "agencies",
            "selectedParentSubSidebarOptions": "company",
            "key": "settings"
        };
        case (/^\/clients\/company\/agencies/).test(path): return {
            "selectedSubSidebarOptions": "agencies",
            "selectedParentSubSidebarOptions": "company",
            "key": "settings"
        };
        case (/^\/clients\/company\/add-agency/).test(path): return {
            "selectedSubSidebarOptions": "agencies",
            "selectedParentSubSidebarOptions": "company",
            "key": "settings"
        };
        case (/^\/clients\/company\/.*\/agency-form/).test(path): return {
            "selectedSubSidebarOptions": "agencies",
            "selectedParentSubSidebarOptions": "company",
            "key": "settings"
        };
        case (/^\/clients\/company\/.*\/invite-agency-users/).test(path): return {
            "selectedSubSidebarOptions": "agencies",
            "selectedParentSubSidebarOptions": "company",
            "key": "settings"
        };


        // ------------------------------------- COMPANY -------------------------------------


        // ------------------------------------- USER PROFILE -------------------------------------
        case (/^\/clients\/users\/.*\/view-profile/).test(path): return {
            "selectedSubSidebarOptions": "add-team",
            "selectedParentSubSidebarOptions": "company",
            "key": "settings"
        };
        // ------------------------------------- PROFILE -------------------------------------


        // ------------------------------------- PROFILE -------------------------------------
        case (/^\/clients\/data-privacy\/privacy-policy/).test(path): return {
            "selectedSubSidebarOptions": "privacy-policy",
            "selectedParentSubSidebarOptions": "data-privacy",
            "key": "settings"
        };
        // ------------------------------------- PROFILE -------------------------------------



        // ------------------------------- ADMIN  -------------------------------
        case (/^\/admins\/activities\/activity/).test(path): return {
            "selectedSubSidebarOptions": "activities",
            "selectedParentSubSidebarOptions": "activities",
            "key": "activities"
        };
        case (/^\/admins\/clients\/client/).test(path): return {
            "selectedSubSidebarOptions": "clients",
            "selectedParentSubSidebarOptions": "clients",
            "key": "clients"
        };
        case (/^\/admins\/clients\/new/).test(path): return {
            "selectedSubSidebarOptions": "clients",
            "selectedParentSubSidebarOptions": "new",
            "key": "clients"
        };
        case (/^\/admins\/clients\/.*\/add-users/).test(path): return {
            "selectedSubSidebarOptions": "clients",
            "selectedParentSubSidebarOptions": "add-users",
            "key": "clients"
        };
        case (/^\/admins\/clients\/.*\/integrations/).test(path): return {
            "selectedSubSidebarOptions": "clients",
            "selectedParentSubSidebarOptions": "integrations",
            "key": "clients"
        };
        case (/^\/admins\/clients\/.*\/edit/).test(path): return {
            "selectedSubSidebarOptions": "clients",
            "selectedParentSubSidebarOptions": "edit",
            "key": "clients"
        };
        case (/^\/admins\/users/).test(path): return {
            "selectedSubSidebarOptions": "users",
            "selectedParentSubSidebarOptions": "users",
            "key": "users"
        };
        // ------------------------------- ADMIN  -------------------------------


        // ------------------------------- AGENCY USER ---------------------------------
        case (/^\/agency\/activities/).test(path): return {
            "selectedSubSidebarOptions": "activities",
            "selectedParentSubSidebarOptions": "activities",
            "key": "activities"
        };
        case (/^\/agency\/jobs/).test(path): return {
            "selectedSubSidebarOptions": "jobs",
            "selectedParentSubSidebarOptions": "jobs",
            "key": "jobs"
        };
        case (/^\/agency\/users/).test(path): return {
            "selectedSubSidebarOptions": "users",
            "selectedParentSubSidebarOptions": "users",
            "key": "users"
        };
        case (/^\/agency\/users\/.*\/profile/).test(path): return {
            "selectedSubSidebarOptions": "users",
            "selectedParentSubSidebarOptions": "users",
            "key": "settings"
        };
        case (/^\/agency\/users\/add-user/).test(path): return {
            "selectedSubSidebarOptions": "users",
            "selectedParentSubSidebarOptions": "users",
            "key": "settings"
        };
        case (/^\/agency\/users\/edit-user/).test(path): return {
            "selectedSubSidebarOptions": "users",
            "selectedParentSubSidebarOptions": "users",
            "key": "settings"
        };
        case (/^\/agency\/profile/).test(path)    :    return {  "selectedSubSidebarOptions":"profile",
                                                                                  "selectedParentSubSidebarOptions" :"profile",
                                                                                  "key" : "settings"};
        // ------------------------------- AGENCY USER  ---------------------------------                                                                        


        default: return {
            "selectedSubSidebarOptions": "activities",
            "selectedParentSubSidebarOptions": "activities",
            "key": "activities"
        };

    }

}